export default __webpack_public_path__ + "static/media/openstreetmap_changesets.feb3a43a.png";